import { faBell } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from 'react-bootstrap';

interface Props {
    onAllowClick: () => void,
    onHide: () => void,
    show: boolean
}

export const PushNotificationModalDisplay = ({
    onHide,
    onAllowClick,
    show,
}: Props): React.ReactElement<any, any> => {
    return (
        <Modal show={show} size='sm' onHide={onHide}>
            <Modal.Header
                closeButton
                className='border-0'
                style={{ backgroundColor: '#EDEFF8' }}
            >
            </Modal.Header>
            <div
                className='d-flex justify-content-center'
                style={{ padding: '0 5rem', backgroundColor: '#EDEFF8' }}
            >
                <div
                    className='ratio ratio-1x1 rounded-top border-bottom-0 text-white'
                    style={{ border: '5px solid black', background: '#444' }}
                >
                    <div className='px-5 align-items-center d-flex'>
                        <FontAwesomeIcon style={{ height: 'auto' }} icon={faBell} />
                    </div>
                </div>
            </div>
            <Modal.Body>
                <div className='fs-4 fw-bold text-primary mb-4'>Allow push notifications</div>
                <p>
                    We can notify you when your
                    {' '}
                    <span className='fw-bold'>consultant is ready</span>
                    {' '}
                    and your appointment can start.
                </p>
                <p className='mb-4'>
                    For this to be possible, you need to allow push notifications for this page.
                </p>
                <div className='d-grid gap-2'>
                    <Button variant='primary' onClick={onAllowClick}>
                        Allow push notifications
                    </Button>
                    <Button variant='link-dark' className='text-decoration-none' onClick={onHide}>
                        Skip
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
